(function () {
  if (window.__lumenCurrency) return;
  window.__lumenCurrency = true;

  function shop() {
    return (window.Shopify && window.Shopify) || {};
  }

  function currencyInfo() {
    var s = shop();
    var cur = s.currency || {};
    var code = cur.active || "USD";
    var rate = parseFloat(cur.rate);
    if (!isFinite(rate) || rate <= 0) rate = 1;
    var country = (s.country || "").toUpperCase();
    var locale = s.locale || navigator.language || "en";
    // Prefer region locales so AUD shows as A$, GBP as £, etc.
    if (country === "AU") locale = "en-AU";
    else if (country === "GB" || country === "UK") locale = "en-GB";
    else if (country === "CA") locale = "en-CA";
    else if (country === "US") locale = "en-US";
    else if (country === "NZ") locale = "en-NZ";
    return { code: code, rate: rate, locale: locale, country: country };
  }

  function money(usd) {
    try {
      var info = currencyInfo();
      var amount = Number(usd) * info.rate;
      var formatted = new Intl.NumberFormat(info.locale, {
        style: "currency",
        currency: info.code,
        currencyDisplay: "symbol"
      }).format(amount);
      // en-AU / en-CA often render just "$" — disambiguate from USD
      if (info.code === "AUD" && formatted.indexOf("A$") === -1) {
        formatted = formatted.replace("$", "A$");
      } else if (info.code === "CAD" && formatted.indexOf("CA$") === -1) {
        formatted = formatted.replace("$", "CA$");
      }
      return formatted;
    } catch (e) {
      return "$" + Number(usd).toFixed(2);
    }
  }

  function rewriteRoot(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var n = 0; n < nodes.length; n++) {
      var t = nodes[n].nodeValue;
      if (!t) continue;
      if (
        t.indexOf("[[SHIP:") === -1 &&
        t.indexOf("$6.95") === -1 &&
        t.indexOf("$12.95") === -1
      ) {
        continue;
      }
      // Policy / help copy uses "$6.95" mid-sentence — convert bare USD amounts
      nodes[n].nodeValue = t
        .replace(/\[\[SHIP:([0-9.]+)\]\]/g, function (_, v) {
          return money(v);
        })
        .replace(/\$12\.95/g, money(12.95))
        .replace(/\$6\.95/g, money(6.95));
    }
  }

  function apply() {
    var roots = document.querySelectorAll(
      [
        "[class*=announcement]",
        ".announcement-bar",
        ".header-announcements",
        ".lumen-buy-trust",
        ".lumen-kit",
        ".lumen-oil-hint",
        ".shopify-policy__container",
        ".shopify-policy__body",
        ".shopify-policy__title",
        "[class*=policy]",
        "dialog",
        "[role=dialog]",
        ".drawer",
        ".popover",
        "[popover]",
        ".tooltip",
        "[class*=tooltip]",
        "[class*=shipping]"
      ].join(", ")
    );
    for (var i = 0; i < roots.length; i++) rewriteRoot(roots[i]);
    // Policy page + any mid-sentence $6.95 / $12.95 under main
    rewriteRoot(document.querySelector("main") || document.body);
    document.documentElement.setAttribute(
      "data-lumen-fx",
      currencyInfo().code + ":" + currencyInfo().rate
    );
    if (!apply._fx) {
      apply._fx = true;
      document.dispatchEvent(new CustomEvent("lumen:fx"));
      apply._fx = false;
    }
  }

  function bindRefresh() {
    document.addEventListener(
      "change",
      function (ev) {
        var t = ev.target;
        if (!t) return;
        var name = (t.getAttribute("name") || "").toLowerCase();
        if (
          name.indexOf("country") !== -1 ||
          name.indexOf("locale") !== -1 ||
          name.indexOf("currency") !== -1 ||
          t.closest("localization-form")
        ) {
          setTimeout(apply, 50);
          setTimeout(apply, 400);
        }
      },
      true
    );
    document.addEventListener(
      "submit",
      function (ev) {
        if (ev.target && ev.target.closest && ev.target.closest("localization-form")) {
          setTimeout(apply, 50);
        }
      },
      true
    );
    // Re-run when shipping help / policy UI opens (Horizon ? near shipping)
    document.addEventListener(
      "click",
      function (ev) {
        var el = ev.target;
        if (!el || !el.closest) return;
        var hit = el.closest(
          'a[href*="shipping"], a[href*="policies"], .policy-list-trigger, [class*=tooltip], [class*=popover]'
        );
        if (!hit) return;
        setTimeout(apply, 80);
        setTimeout(apply, 350);
      },
      true
    );
    window.addEventListener("pageshow", apply);
    document.addEventListener("shopify:section:load", apply);
  }

  window.LumenCurrency = {
    money: money,
    refresh: apply,
    info: currencyInfo
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        apply();
        bindRefresh();
      },
      { once: true }
    );
  } else {
    apply();
    bindRefresh();
  }
  document.addEventListener("lumen:currency", apply);
})();
